import React from 'react';
import {
  Box,
  Text,
  ClockIcon,
  CheckCircleIcon,
  MailIcon,
  GlobeIcon,
} from '@razorpay/blade/components';
import { StepType } from '../../types';

const StepIcon = ({ type, actionCode }: { type: StepType; actionCode?: string }) => {
  const iconProps = { size: 'medium' as const };

  if (type === 'trigger') {
    return <ClockIcon {...iconProps} color="interactive.icon.primary.normal" />;
  }

  if (type === 'decision') {
    return (
      <Box
        width="spacing.7"
        height="spacing.7"
        borderRadius="round"
        backgroundColor="surface.background.primary.subtle"
        display="flex"
        alignItems="center"
        justifyContent="center">
        <Text size="small">🤖</Text>
      </Box>
    );
  }

  if (type === 'action') {
    switch (actionCode) {
      case 'approve_or_reject':
        return <CheckCircleIcon {...iconProps} color="feedback.icon.positive.intense" />;
      case 'send_email':
        return <MailIcon {...iconProps} color="interactive.icon.primary.normal" />;
      case 'call_api':
        return <GlobeIcon {...iconProps} color="interactive.icon.primary.normal" />;
      default:
        return <CheckCircleIcon {...iconProps} color="interactive.icon.primary.normal" />;
    }
  }

  return null;
};

export { StepIcon };
